import { useParamsLegacy as useParams } from '@leagueplatform/routing';
import { useWalletDetailQuery } from './use-wallet-detail-query.hook';

export function usePolicyDetailsInformation() {
  const { benefitId } = useParams<{ benefitId: string }>();
  const { data, isLoading } = useWalletDetailQuery(undefined, benefitId);

  const policyTab = data?.content_actions?.find(
    ({ name }) => name === 'Policy Information',
  );

  return {
    title: policyTab?.title ?? '',
    description: policyTab?.description ?? '',
    isLoading,
  };
}
